import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Analityc from "./pages/Analityc";
import HistoryCal from "./pages/HistoryCal";
import Login from "./pages/Login";
import Monitoring from "./pages/Monitoring";
import AlertsPage from "./pages/Alerts";
import LiveTrackingPage from "./pages/LiveTracking";
import { useAuth } from "./context/AuthContext";
import { CheckToken } from "./Api/AuthData";
import Swal from "sweetalert2";

const AuthRoute = ({ element }) => {
  const { isAuthenticated, isLoading, setIsAuthenticated } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const checkToken = async () => {
      try {
        const data = await CheckToken();
        if (data.status === 200) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          Swal.fire({
            icon: 'warning',
            title: 'Sesi Berakhir',
            text: 'Silakan login kembali',
            confirmButtonText: 'OK'
          });
        }
      } catch (error) {
        setIsAuthenticated(false);
        Swal.fire({
          icon: 'error',
          title: 'Sesi Berakhir',
          text: 'Silakan login kembali',
          confirmButtonText: 'OK'
        });
      }
    }
    checkToken();
  }, [location.pathname, setIsAuthenticated]);

  if (isLoading) return null;

  return isAuthenticated ? element : <Navigate to="/" />
}

AuthRoute.propTypes = {
  element: PropTypes.element.isRequired
};


const App = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleSidebarCollapse = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };


  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/monitoring" element={
          <AuthRoute element={
            <div className="flex flex-col min-h-screen">
              <Navbar toggleSidebar={toggleSidebar} />
              <div className="flex-1">
                <Monitoring />
              </div>
            </div>
          } />
        } />

        <Route
          path="/dashboard/*"
          element={
            <AuthRoute element={
              <div className="flex flex-col min-h-screen">
                <Navbar toggleSidebar={toggleSidebar} />
                <div className="flex flex-1">
                  <Sidebar
                    isOpen={isSidebarOpen}
                    toggleSidebar={toggleSidebar}
                    isCollapsed={isSidebarCollapsed}
                    toggleCollapse={toggleSidebarCollapse}
                  />
                  <main className={`flex-1 overflow-y-auto transition-all duration-300 ${isSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-[264px]'}`}>
                    {/* Nested Routes for Dashboard pages */}
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      {/* <Route path="/" element={'test'} /> */}
                      <Route path="history" element={<HistoryCal />} />
                      <Route path="analytic" element={<Analityc />} />
                      <Route path="alerts" element={<AlertsPage />} />
                      <Route path="live-tracking" element={<LiveTrackingPage />} />
                    </Routes>
                  </main>
                </div>
              </div>
            } />
          }
        />
      </Routes>
    </div>
  );
}

export default App;
